var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "soutien_coeur-vert_eau 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8293 34.864C19.7413 34.864 18.5573 34.8547 17.3453 34.844C16.5573 34.836 15.8773 34.8307 15.3787 34.8307C13.9613 34.8307 12.5947 34.2053 11.2733 33.6013C10.16 33.092 9.00933 32.5653 7.86 32.428C5.31333 32.1213 2.78933 32.4253 2.764 32.428C2.32533 32.4827 1.92667 32.1693 1.872 31.732C1.81867 31.2933 2.12933 30.8947 2.568 30.84C2.67867 30.8267 5.312 30.5107 8.04933 30.84C9.44667 31.008 10.7133 31.5867 11.9373 32.1467C13.156 32.704 14.308 33.2307 15.3773 33.2307C15.8827 33.2307 16.5667 33.2373 17.3587 33.244C20.0387 33.2693 24.524 33.3107 25.6147 33.0933C25.9893 33.004 27.8373 31.8733 31.1893 29.22C34.1733 26.8573 36.0933 25.0667 36.3853 24.58C36.6027 24.2173 36.5773 23.8027 36.32 23.5507C35.964 23.2 35.276 23.2733 34.524 23.7413C32.9293 24.7333 27.5853 27.3813 27.3587 27.4933C27.1253 27.608 26.852 27.604 26.624 27.48C26.4373 27.38 26.3 27.2107 26.24 27.0107C26.136 26.892 25.3133 26.1507 21.3907 26.4093C18.2827 26.6147 16.6533 25.672 15.08 24.7613L15.068 24.7547C13.108 23.62 10.908 23.2987 7.22 23.6053L2.73733 24.0013C2.29867 24.0413 1.90933 23.7147 1.87067 23.2747C1.832 22.8347 2.15733 22.4467 2.59733 22.408L7.084 22.012C10.464 21.7307 13.2493 21.8533 15.8707 23.3707L15.8827 23.3773C17.3747 24.2413 18.664 24.9867 21.2867 24.8147C23.6933 24.656 25.4693 24.8307 26.5613 25.332C26.8533 25.4667 27.076 25.6147 27.2467 25.7627C28.712 25.0307 32.4547 23.1453 33.68 22.3827C35.3667 21.3333 36.7307 21.708 37.4427 22.4107C38.224 23.18 38.3533 24.4107 37.7573 25.404C37.036 26.6053 32.952 29.8667 32.1413 30.508C30.3 31.964 27.0453 34.44 25.9293 34.6627C25.136 34.8213 23.208 34.8653 20.8293 34.8653V34.864Z",
    fill: "url(#paint0_linear_0_81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3427 30.412C17.168 30.412 16.06 30.3333 15.188 30.0987C13.9347 29.7613 11.796 28.6707 11.7053 28.6253C11.312 28.424 11.156 27.9427 11.3573 27.5493C11.5587 27.156 12.04 27 12.4333 27.2013C12.4547 27.212 14.5133 28.2613 15.6027 28.5547C17.2107 28.9867 20.1373 28.776 22.2733 28.6227C23.2493 28.552 24.092 28.492 24.7293 28.4893C25.5987 28.4867 26.264 28.004 26.3813 27.5587C26.4507 27.2973 26.2853 27.0493 25.8907 26.8227C25.508 26.6027 25.376 26.1133 25.596 25.7307C25.816 25.348 26.3053 25.216 26.688 25.436C27.7267 26.0333 28.1893 26.9813 27.9267 27.9707C27.6013 29.1947 26.2573 30.0853 24.732 30.0893C24.1507 30.0907 23.3333 30.1493 22.3867 30.2173C21.1187 30.308 19.6853 30.412 18.34 30.412H18.3427Z",
    fill: "url(#paint1_linear_0_81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.78 8.41629C22.3199 6.49564 24.8653 6.63622 26.1443 7.74051V7.74148C27.3808 8.80918 27.7202 11.2524 26.0593 14.1243L26.0525 14.137L26.0456 14.1487C25.5518 15.0607 24.6292 16.0467 23.4665 17.0071C22.385 17.9004 21.1518 18.7246 19.9997 19.4007C18.8484 18.7253 17.6164 17.9019 16.5359 17.01C15.3741 16.0511 14.4518 15.0679 13.9587 14.1585L13.9529 14.1458L13.946 14.1341L13.7956 13.8655C12.3022 11.1026 12.6586 8.77518 13.8562 7.74148V7.74051C15.1334 6.63686 17.6789 6.49499 19.2204 8.41629L20.0007 9.38895L20.78 8.41629Z",
    stroke: "var(--stroke-0, #119ED9)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_81",
    x1: 1.64572,
    y1: 22.3032,
    x2: 27.0893,
    y2: 46.0726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_81",
    x1: 11.1677,
    y1: 25.5509,
    x2: 20.9793,
    y2: 36.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesHeart);
export default __webpack_public_path__ + "static/media/services_heart.af904e850a0b91077748809abdc60c3a.svg";
export { ForwardRef as ReactComponent };